"use client";
import { jsxs as b, jsx as e } from "react/jsx-runtime";
import l from "clsx";
import { useRef as u, useCallback as h } from "react";
import '../../assets/media-banner.css';const n = {
  "media-banner": "_media-banner_5hupn_1",
  "media-banner--curved": "_media-banner--curved_5hupn_9",
  "media-banner__image": "_media-banner__image_5hupn_47",
  "media-banner__icon": "_media-banner__icon_5hupn_80",
  "media-banner__icon-circle": "_media-banner__icon-circle_5hupn_93",
  "media-banner__container": "_media-banner__container_5hupn_105",
  "media-banner__inner": "_media-banner__inner_5hupn_112",
  "media-banner__content": "_media-banner__content_5hupn_132"
}, N = ({
  image: r,
  icon: _,
  variant: d,
  children: m,
  className: t,
  ...o
}) => {
  const a = u(null), s = h(() => {
    const i = a == null ? void 0 : a.current, c = i == null ? void 0 : i.nextElementSibling;
    c && c.scrollIntoView({ behavior: "smooth" });
  }, [a]);
  return /* @__PURE__ */ b(
    "div",
    {
      "data-testid": "media-banner",
      ref: a,
      className: l(
        {
          [n["media-banner"]]: !0,
          [n["media-banner--curved"]]: d === "curved",
          [n["media-banner--flat"]]: d === "flat"
        },
        t
      ),
      ...o,
      children: [
        r && /* @__PURE__ */ e(
          "div",
          {
            className: n["media-banner__image"],
            "data-testid": "media-banner-image",
            children: r
          }
        ),
        /* @__PURE__ */ e("div", { className: n["media-banner__container"], children: /* @__PURE__ */ e("div", { className: n["media-banner__inner"], children: /* @__PURE__ */ e("div", { className: n["media-banner__content"], children: m }) }) }),
        _ && /* @__PURE__ */ e("div", { className: n["media-banner__icon"], children: /* @__PURE__ */ e(
          "button",
          {
            onClick: s,
            className: n["media-banner__icon-circle"],
            type: "button",
            "aria-hidden": !0,
            "data-testid": "media-banner-icon-button",
            children: _
          }
        ) })
      ]
    }
  );
};
export {
  N as MediaBanner
};
